import BimView from "interfaces/models/bimView";
import {
  DocumentKeyplanDTO,
  UpdateEditorDataFormKeyLabel,
  UpdateEditorDataFormText,
} from "interfaces/models/documentKeyplan";
import { KeyplanLayoutDTO } from "interfaces/models/keyplanLayout";

// Define the structure for the entire store state
export interface KeyplanState {
  keyplanLayout: KeyplanLayoutDTO | null;
  mapDocumentKeyplan: Map<string, DocumentKeyplanDTO> | null;
  bimViews: BimView[] | null;

  urn: string | null | undefined;
  documentFormatId: string | null | undefined;
  documentId: string | null | undefined;

  isFetchingBimViews: boolean;
  isEditMode: boolean;
  isFixed: boolean;
  resource: {
    inspectionTypeName: string;
    inspectionGroupName: string;
    revitFileName: string;
  } | null;

  // Map<documentKeyplanId, Record<frameId, UpdateEditorDataFormText>>
  mapTempFormText: Map<string, Record<string, UpdateEditorDataFormText>>;

  // Map<documentKeyplanId, Record<pinId, UpdateEditorDataFormText>>
  mapTempFormKeyLabel: Map<
    string,
    Record<string, UpdateEditorDataFormKeyLabel>
  >;
  pageRatioEditMode: number;

  isRotateMode: boolean;
  isFetchingKeyplanLayout: boolean;
  isFetchingDocumentKeyplans: boolean;
}

// Define the actions that can be performed on the store
type KeyplanActionType =
  | "FETCHING_DOCUMENT_KEYPLANS"
  | "FETCHING_KEYPLAN_LAYOUT"
  | "SET_DOCUMENT_FORMAT_ID"
  | "SET_DOCUMENT_ID"
  | "SET_KEYPLAN_LAYOUT"
  | "SET_DOCUMENT_KEYPLANS"
  | "SET_BIM_VIEWS"
  | "SET_IS_FETCHING_BIM_VIEWS"
  | "RESET_STATE"
  | "ADD_TEMP_DOCUMENT_KEYPLAN"
  | "REMOVE_TEMP_DOCUMENT_KEYPLAN"
  | "SET_IS_EDIT_MODE"
  | "UPDATE_DOCUMENT_KEYPLAN"
  | "FIXED_KEYPLAN"
  | "SET_RESOURCE"
  | "UPDATE_EDITOR_FORM_TEXT"
  | "UPDATE_TEMP_EDITOR_FORM_TEXT"
  | "UPDATE_EDITOR_FORM_TEXT_FROM_TEMP"
  | "CLEAR_TEMP_EDITOR_FORM"
  | "UPDATE_EDITOR_FORM_KEYLABEL"
  | "UPDATE_TEMP_EDITOR_FORM_KEYLABEL"
  | "UPDATE_EDITOR_FORM_KEYLABEL_FROM_TEMP"
  | "TOGGLE_CHANGE_ROTATE_MODE"
  | "SET_PAGE_RATIO_EDIT_MODE"
  | "SET_URN";

interface KeyplanActionMap {
  FETCHING_DOCUMENT_KEYPLANS: boolean;
  FETCHING_KEYPLAN_LAYOUT: boolean;
  SET_DOCUMENT_FORMAT_ID: KeyplanState["documentFormatId"];
  SET_DOCUMENT_ID: KeyplanState["documentId"];
  SET_KEYPLAN_LAYOUT: KeyplanState["keyplanLayout"];
  SET_DOCUMENT_KEYPLANS: DocumentKeyplanDTO[] | undefined;
  SET_BIM_VIEWS: KeyplanState["bimViews"];
  SET_IS_FETCHING_BIM_VIEWS: KeyplanState["isFetchingBimViews"];
  RESET_STATE: void;
  ADD_TEMP_DOCUMENT_KEYPLAN: Partial<DocumentKeyplanDTO>;
  REMOVE_TEMP_DOCUMENT_KEYPLAN: string;
  SET_IS_EDIT_MODE: boolean;
  UPDATE_DOCUMENT_KEYPLAN: Partial<DocumentKeyplanDTO> & { id: string };
  FIXED_KEYPLAN: boolean;
  SET_RESOURCE: KeyplanState["resource"];
  UPDATE_EDITOR_FORM_TEXT: UpdateEditorDataFormText;
  UPDATE_TEMP_EDITOR_FORM_TEXT: UpdateEditorDataFormText;
  UPDATE_EDITOR_FORM_TEXT_FROM_TEMP: string;
  CLEAR_TEMP_EDITOR_FORM: void;
  UPDATE_EDITOR_FORM_KEYLABEL: UpdateEditorDataFormKeyLabel;
  UPDATE_TEMP_EDITOR_FORM_KEYLABEL: UpdateEditorDataFormKeyLabel;
  UPDATE_EDITOR_FORM_KEYLABEL_FROM_TEMP: string;
  TOGGLE_CHANGE_ROTATE_MODE: boolean;
  SET_PAGE_RATIO_EDIT_MODE: number;
  SET_URN: string | null | undefined;
}

export type KeyplanAction = {
  [K in KeyplanActionType]: KeyplanActionMap[K] extends void
    ? { type: K; payload?: undefined }
    : { type: K; payload: KeyplanActionMap[K] };
}[KeyplanActionType];

export const defaultState: KeyplanState = {
  keyplanLayout: null,
  mapDocumentKeyplan: null,
  bimViews: null,

  documentFormatId: null,
  documentId: null,
  urn: null,

  isFetchingBimViews: true,
  isEditMode: false,
  isFixed: false,
  resource: null,

  mapTempFormText: new Map(),
  mapTempFormKeyLabel: new Map(),
  isRotateMode: false,
  pageRatioEditMode: 1,

  isFetchingKeyplanLayout: true,
  isFetchingDocumentKeyplans: true,
};
